import _ from "lodash"

export default function (payload, findFn, userId) {
  let planbook = findFn("planbook", payload.planbook.id)
  let rotationCalendar = findFn(
    "rotation-calendar",
    planbook.relationships.rotationCalendar.data.id
  )
  let rotation = _.find(rotationCalendar.attributes.rotations, (rotation) => {
    return rotation.id === payload.annotation.attributes.rotationId
  })
  return {
    planbook: planbook,
    user: findFn("user", userId),
    rotation: rotation,
  }
}
